export const SET_SHOW_DISPUTE_PROCESS = 'ORDER/SET_SHOW_DISPUTE_PROCESS';

export const setShowDisputeProcess = (showDisputeProcess: boolean) => ({
  type: SET_SHOW_DISPUTE_PROCESS,
  payload: showDisputeProcess,
});
